import { useContext } from "react";
import { ProductFruits } from "react-product-fruits";
import { AuthContext } from "../contexts/AuthContext";

const ProductFruitsWrapper = () => {
  const { user, organisation } = useContext(AuthContext);
  const workspaceCode = import.meta.env.VITE_PRODUCT_FRUITS_WORKSPACE_CODE;

  if (!workspaceCode) return null;

  const productFruitsConfig = {
    language: "en",
    user: {
      username: user?.email || "guest",
      email: user?.email || "guest",
      firstname: user?.firstName || "Guest",
      lastname: user?.lastName || "User",
      signUpAt: user?.createdAt
        ? new Date(user.createdAt).toISOString()
        : new Date().toISOString(),
      props: {
        userLevel: user?.userLevel || "unknown",
        orgType: organisation?.type || "unknown",
      },
    },
  };

  return (
    <ProductFruits
      workspaceCode={workspaceCode}
      language={productFruitsConfig.language}
      user={productFruitsConfig.user}
      lifeCycle="unmount"
    />
  );
};

export default ProductFruitsWrapper;
